module.exports = new __parcel__URL__("decision-dark.73f4b063.png").toString();